import { inmunetApi } from '../../../api';

export const getHistorial = async(id) => {

    try {

        const { data } = await inmunetApi.get(`/historial/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener historial de paciente';

        return data;

    } catch (error) {

        throw new Error('Error al obtener historial de paciente');

    }

};